import { AfterViewInit, ChangeDetectorRef, Component, ViewChild } from '@angular/core'
import { MatSort, MatSortModule, Sort } from '@angular/material/sort'
import { MatTableDataSource, MatTableModule } from '@angular/material/table'
import { MatPaginator, MatPaginatorIntl, MatPaginatorModule } from '@angular/material/paginator'
import { RouterModule } from '@angular/router'
import { MatIconModule } from '@angular/material/icon'
import { MatButtonModule } from '@angular/material/button'
import {MatExpansionModule} from '@angular/material/expansion'
import { MatCheckboxModule } from '@angular/material/checkbox'
import { FormsModule } from '@angular/forms'

import { LiveAnnouncer } from '@angular/cdk/a11y'

import { MetricsService } from './services/season-metrics.service'
import { Metric } from '../../core/models/season-metrics.model'
import { SeasonMetricsFiltersComponent } from './components/season-metrics-filters/season-metrics-filters.component'
import { CommonModule } from '@angular/common'
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'
import { GetValuePipe } from '../../shared/pipes/get-value.pipe'

@Component({
    selector: 'season-metrics-component',
    standalone: true,
    imports: [
        CommonModule,
        MatTableModule,
        MatPaginatorModule,
        MatSortModule,
        MatIconModule,
        MatButtonModule,
        MatExpansionModule,
        MatCheckboxModule,
        FormsModule,
        GetValuePipe,
        SeasonMetricsFiltersComponent,
        MatProgressSpinnerModule,
        RouterModule
    ],
    templateUrl: 'season-metrics.component.html',
    styleUrl: 'season-metrics.component.css'
})

export class SeasonMetricsComponent implements AfterViewInit {
  constructor(public service: MetricsService, private _liveAnnouncer: LiveAnnouncer) {}
  panelOpenState:boolean = false
  tableLoaded:boolean = false
  submitted:boolean = false

  displayedColumns: string[] = [ 'name', 'season', 'games_played' ]
  
  dataSource: MatTableDataSource<Metric, MatPaginator> = new MatTableDataSource<Metric, MatPaginator>()

  @ViewChild(MatSort) sort: MatSort = new MatSort
  @ViewChild(MatPaginator) paginator: MatPaginator = new MatPaginator(new MatPaginatorIntl(), ChangeDetectorRef.prototype)

  ngAfterViewInit() {
    //Subscribe to data change event
    this.service.filtersSubmittedEvent
    .subscribe(() =>{
      this.submitted = true
      this.panelOpenState = false
      this.reloadTable()
    })
  }

  reloadTable(){
    this.service.fetchFilteredMetrics()
    .subscribe(response => {
      this.dataSource = new MatTableDataSource(response as Metric[])
      setTimeout(() =>{
        this.dataSource.paginator = this.paginator
        this.dataSource.sort = this.sort
      })
      this.displayedColumns = [ 'name', 'season', 'games_played' ]
      this.service.metricsSelected.forEach(e=>this.displayedColumns.push(e.field))
      this.tableLoaded = true
      this.submitted = false
      this.service.filters.reset()
    })
  }

  announceSortChange(sortState: Sort) {
    if (sortState.direction) this._liveAnnouncer.announce(`Sorted ${sortState.direction}ending`)
    else this._liveAnnouncer.announce('Sorting cleared')
  }
}
